import {
    UI_BUTTON_PRESSED,
    SET_SPINBUTTON_VISIBILITY,
    SET_REPLAYURL,
    ON_RESIZE,
    TOGGLE_DIMENSIONS,
    SET_POPUP_SCREEN,
    SET_AUTOPLAY_RESTART,
    SET_SPIN_RING_ANIMATION,
} from './constants'

export function uiButtonPressed(buttonName) {
    return {
        type: UI_BUTTON_PRESSED,
        buttonName
    }
}

/**
 * Sets the visibility of the spin button.
 * @param {Boolean} spinButtonVisible - Boolean to toggle visibility.
 */
export function setSpinButtonVisibility(spinButtonVisible) {
    return {
        type: SET_SPINBUTTON_VISIBILITY,
        spinButtonVisible,
    }
}

/**
 * Propagates a resize event so that the coordinates can be updated.
 */
export function onResize() {
    return { type: ON_RESIZE }
}

export function setReplayUrl(replayUrl) {
    return { type: SET_REPLAYURL, replayUrl }
}

/**
 * Action called to toggle dimensionboxes debug, using the Ui tab in the DevTools.
 */
export function toggleDimensions() {
    return { type: TOGGLE_DIMENSIONS }
}

/**
 * Action called to open the pop up screen, in a specific sub-category (e.g. autoplay)
 * @param {string} popupScreen - The name of the sub-category, which should be opened.
 * @returns {type: string, popupScreen: string}
 */
export function setPopupScreen(popupScreen) {
    return {
        type: SET_POPUP_SCREEN,
        popupScreen
    }
}

/**
 * Action called to set autoPlay popup visibility after autoPlay ends
 * @param {bool} autoPlayReStart - Bollean to set autoPlay popup visibility 
 * @returns {type: string, autoPlayReStart: boolean}
 */
 export function setAutoPlayReStart(autoPlayReStart) {
    return {
        type: SET_AUTOPLAY_RESTART,
        autoPlayReStart
    }
}

/**
 * Action called to control spin ring visibility
 * @param {bool} enableSpinRingAnimation 
 * @returns {type: string, enableSpinRingAnimation: boolean}
 */
export function setSpinRingAnimation(enableSpinRingAnimation) {
    return {
        type: SET_SPIN_RING_ANIMATION,
        enableSpinRingAnimation
    }
}